import { NavLink } from 'react-router-dom';

const Footer = () => (
  <footer>
    <div className="footer-grid">
      <div className="footer-brand">
        <img src='/my_fundz.png' alt="My Fundz Logo" className="footer-logo" />
        <p className="footer-tagline">MYFUNDZ</p>
        <p>Trusted Financial Planning Services In Puducherry</p>
        <p>Services Handled Across India</p>
        <p>Consultations By Appointment.</p>
        <p>Legacy Of Trust Since 1985.</p>
        <p>Your Financial Partner For Life.</p>
        <div className="social-links">
          <span className="social-icon" aria-label="LinkedIn">in</span>
          <span className="social-icon" aria-label="Facebook">f</span>
          <span className="social-icon" aria-label="YouTube">▶</span>
        </div>
      </div>
      <div className="footer-section">
        <h4>Services</h4>
        <ul>
          <li><span className="footer-text-link">Portfolio Management Services (PMS)</span></li>
          <li><span className="footer-text-link">Retirement Planning (NPS & Bonds)</span></li>
          <li><span className="footer-text-link">Corporate Deposit</span></li>
          <li><span className="footer-text-link">Insurance Planning</span></li>
        </ul>
      </div>
      <div className="footer-section">
        <h4>Pages</h4>
        <ul>
          <li><NavLink to="/about">About Us</NavLink></li>
          <li><NavLink to="/calculators">Calculators</NavLink></li>
          <li><NavLink to="/services">Services</NavLink></li>
          <li><NavLink to="/why-choose-us">Why Choose Us</NavLink></li>
          <li><NavLink to="/contact">Contact Us</NavLink></li>
        </ul>
      </div>
      <div className="footer-section">
        <h4>Let's Connect</h4>
        <ul>
          <li><span className="footer-text-link">Connect With A Trusted Investment Advisor Today</span></li>
          <li><span className="footer-text-link">Start Planning Your Financial Future</span></li>
          <li><NavLink to="/contact">Contact Us</NavLink></li>
        </ul>
      </div>
    </div>
    <div className="footer-bottom">
      <p>2025 MYFUNDZ. All Right Reserved</p>
      <div className="footer-bottom-links">
        <span className="footer-text-link">Privacy Policy</span>
        <span className="footer-text-link">Term Of Use</span>
      </div>
    </div>
  </footer>
);

export default Footer;
